var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('learningCenterService', ['$http', function ($http) {
    return {
        getProjects: function (count) {
            return $http.get('storefrontapi/learningcenter/embroideryprojects?count=' + count);
        },
        getLookbooks: function (count) {
            return $http.get('storefrontapi/learningcenter/toplookbooks?count=' + count);
        },
        getRandomReviews: function (count) {
            return $http.get('storefrontapi/getrandomreviews?count=' + count);
        },
        getDynamicContentBySectionName: function (sectionName) {
            return $http.get('storefrontapi/learningcenter/getdynamicconentbysectionname?sectionname=' + sectionName);
        }
    }
}]);
